import { render, staticRenderFns } from "./isr-pago-inmenzaciones-retiro.vue?vue&type=template&id=2d8403cb&lang=html&"
import script from "./isr-pago-inmenzaciones-retiro.vue?vue&type=script&lang=js&"
export * from "./isr-pago-inmenzaciones-retiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports